import { WSPillProps } from "@wingspanhq/fe-component-library";
import {
  RequirementStatus,
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileNotNoneContext } from "../../../../selectors/selectorIsSharedFileNotNoneContext";
import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps,
  RequirementTableItemData
} from "../../../../types";

export const getSharedFileRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  sharedFileRequest: SharedFileRequest | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;

  let secondaryText: string | undefined;

  if (requirement.status === RequirementStatus.COMPLETED) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    secondaryText = undefined;
  } else if (
    selectorIsSharedFileNotNoneContext(sharedFileRequest?.contextType) &&
    sharedFileRequest?.status === SharedFileRequestStatus.FAILED
  ) {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
    secondaryText = "Submitted with failed validations";
  } else if (
    selectorIsSharedFileNotNoneContext(sharedFileRequest?.contextType) &&
    sharedFileRequest?.status === SharedFileRequestStatus.PROCESSING
  ) {
    pill = {
      theme: "neutral",
      text: "Processing",
      icon: "time"
    };
    secondaryText = undefined;
  } else {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    }
  }

  return {
    pill,
    secondaryText
  };
};
